import React from 'react';
import { CheckIcon } from 'lucide-react';
import type { SortCard } from '../../data/savanna';
import { sortValueLabels } from '../../data/savanna';
import type { SortValue } from '../../types/demo';
interface SortingCardProps {
  card: SortCard;
  value?: SortValue;
  onSelect: (value: SortValue) => void;
}
const VALUES: SortValue[] = ['helpNow', 'moreFacts', 'canWait'];
export function SortingCard({
  card,
  value,
  onSelect
}: SortingCardProps) {
  const headingId = `sort-${card.id}`;
  return <li className="flex h-full flex-col rounded-2xl border border-line bg-paper p-5 hc-strong" data-id="element-552" data-mp="29pywugpcj96x">
      <h2 id={headingId} className="font-display text-xl font-semibold text-forest" data-id="element-553" data-mp="24z8qp193j2b6">
        {card.label}
      </h2>
      <div role="group" aria-labelledby={headingId} className="mt-3 flex flex-col gap-2" data-id="element-554" data-mp="201gwu1ow564c">
        {VALUES.map(option => {
        const selected = value === option;
        return <button key={option} type="button" aria-pressed={selected} onClick={() => onSelect(option)} className={`flex min-h-[44px] items-center justify-between gap-2 rounded-xl border px-4 text-left transition-colors duration-150 ease-out hc-strong ${selected ? 'border-teal bg-teal font-bold text-white' : 'aero-pill border-line text-ink hover:bg-sand'}`} data-id="element-555" data-mp="2sp31zedroitb">
              {sortValueLabels[option]}
              {selected && <CheckIcon size={16} aria-hidden="true" data-id="element-556" data-mp="vcew4aiwrtgp" />}
            </button>;
      })}
      </div>
      <div className="mt-auto pt-4" data-id="element-557" data-mp="10ecl7ldzpihk">
        {value ? <p key={value} className="anim-enter rounded-xl bg-sand px-4 py-3 text-ink" data-id="element-558" data-mp="me1uqjgle5wx">
            {card.feedback[value]}
          </p> : <p className="text-sm text-ink/80" data-id="element-559" data-mp="reh5r4dej1bq">No choice yet. That is fine.</p>}
      </div>
    </li>;
}